<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Suivi du reporting mensuel</h2>

        <b-col cols="10">
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-date" label-for="input-date">
                        <template v-slot:label>
                            <label-custom
                                    label="Mois"
                                    tooltip="Indiquer le mois du reporting"
                                    :required="true">
                            </label-custom>
                        </template>
                        <vue-monthly-picker
                                id="input-date"
                                dateFormat="MM/YYYY"
                                :monthLabels="monthLabels"
                                v-model="date"
                                @selected="search">
                        </vue-monthly-picker>
                        <div class="typo-warning" v-if="!date">
                            Ce champs est obligatoire
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="1" offset="7">
<!--                    <b-button v-if="date" type="button" variant="success" @click="exporter">Exporter</b-button>-->
                    <b-button type="button" variant="success" v-b-modal="'modal-choix-date-mensuel'">Exporter</b-button>
                    <b-modal
                        id="modal-choix-date-mensuel"
                        title="Choisir l'interval de dates"
                        ok-title="Confirmer"
                        cancel-title="Annuler"
                        hide-footer
                        @ok="preventOk">
                      <ReportingChoixDateMensuel></ReportingChoixDateMensuel>
                    </b-modal>
                </b-col>
            </b-row>

            <b-card header="Filtres de recherche" class="mb-3 mt-3">
                <b-row>
                    <b-col>
                        <b-form-group id="input-group-marches" label-for="input-marches">
                            <template v-slot:label>
                                <label-custom
                                        label="Marché"
                                        :tooltip=libelles.infoBulleNumMarche>
                                </label-custom>
                            </template>
                            <AutocompleteCustom
                                    id="input-marches"
                                    :items="marcheIdsItems"
                                    v-model="marcheId"
                                    @search="onMarcheSearch"
                                    :clear="ligneId.length"
                                    :placeholder=libelles.selectionnerMarche
                            >
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-lignes"
                                      label="Ligne" label-for="input-lignes"
                        >
                            <MultiselectCustom 
                                    :options="lignes"
                                    v-model="ligneId"
                                    :defaultLabel="'Sélectionner une ligne'"
                                    :required="true"
                                    @change="marcheId = null; search();"
                                    id="input-lignes"
                            >
                            </MultiselectCustom>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-statut"
                                      label="Statut" label-for="input-statut">
                            <b-form-select
                                    id="input-statut"
                                    v-model="statut"
                                    @change="search">
                                <b-form-select-option :value="null">
                                    Tous
                                </b-form-select-option>
                                <b-form-select-option value="OK">
                                    Reporting fait
                                </b-form-select-option>
                                <b-form-select-option
                                        value="KO">
                                    Reporting non fait
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <div v-if="reportingResult">
                <b-row class="mb-3 justify-content-center">
                    <b-col cols="2">
                        <b-button size="sm" variant="success">Fait dans les temps</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" variant="warning">Fait en retard ou modifié</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" variant="danger">Non fait</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" variant="secondary">Non demandé</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" variant="primary">Dispense utilisateur</b-button>
                    </b-col>
                    <b-col cols="2">
                      <b-button size="sm" class="CLOTURE">Marché cloturé</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" class="DISPENSE_FORMULAIRE">Fait malgré dispense</b-button>
                    </b-col>
                </b-row>
                <b-table striped hover
                         :no-local-sorting="true"
                         :items="reportingTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{row.index + 1}}
                        </div>
                    </template>
                    <template v-slot:cell(statutEmpreinte)>
                    </template>
                    <template v-slot:cell(statutEffectifs)>
                    </template>
                    <template v-slot:cell(statutAccidentologie)>
                    </template>
                </b-table>
            </div>
        </b-col>
    </div>
</template>

<script>
  import ReportingStore from "../../stores/ReportingStore";
  import ReportingSearchDto from "../../dtos/ReportingSearchDto";
  import VueMonthlyPicker from "vue-monthly-picker";
  import LabelCustom from "../../components/LabelCustom";
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import MultiselectCustom from "../../components/MultiselectCustom";
  import {mois} from "../../constants/enums";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import LigneStore from "../../stores/LigneStore";
  import SessionStore from '@/stores/SessionStore'
  import hasPermission from "../../filters/hasPermission";
  import {momentToDate} from "../../utils/dateUtil";
  import _ from 'lodash';
  import {libelles} from "../../constants/libelles";
  import ReportingChoixDateMensuel from "./ReportingChoixDateMensuel";

  export default {
    components: {
      LabelCustom,
      VueMonthlyPicker,
      AutocompleteCustom,
      MultiselectCustom,
      ReportingChoixDateMensuel
    },
    data() {
      return {
        sessionStoreState: SessionStore.state,
        marcheId: null,
        ligneId: [],
        marches: [],
        lignes: [],
        statut: null,
        reportingResult: null,
        date: null,
        monthLabels: mois,
        libelles: libelles,
        marcheIdsItems: [],
        marchesAdmin: [],
      }
    },
    watch: {
      marcheId() {
        if (this.marcheId) {
          this.ligneId = [];
        }
        this.search();
      }
    },
    computed: {
      fields() {
        const fields = [
          {label: '', key: 'num'},
          {label: 'Référence marché', key: 'referenceMarche'},
          {label: 'Libellé court marché', key: 'libelleCourtMarche'},
        ];
        if (hasPermission(['CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'])) {
          fields.push({label: 'Empreinte économique', key: 'statutEmpreinte', tdClass: 'setBackground'})
        }
        if (hasPermission(['CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'])) {
          fields.push({label: 'Effectifs', key: 'statutEffectifs', tdClass: 'setBackground'})
        }
        if (hasPermission(['CORRESPONDANT_SECURITE_ADMINISTRATEUR'])) {
          fields.push({label: 'Accidentologie', key: 'statutAccidentologie', tdClass: 'setBackground'})
        }
        if (hasPermission(['ADMINISTRATEUR'])) {
          fields.push({label: 'Empreinte économique', key: 'statutEmpreinte', tdClass: 'setBackground'});
          fields.push({label: 'Effectifs', key: 'statutEffectifs', tdClass: 'setBackground'});
          fields.push({label: 'Accidentologie', key: 'statutAccidentologie', tdClass: 'setBackground'});
        }
        return fields;
      },
      reportingTable: function () {
        return this.reportingResult.map(reporting => {
          return {
            referenceMarche: reporting.marche.replace(')', '').split('(')[0],
            libelleCourtMarche: reporting.marche.replace(')', '').split('(')[1],
            statutEmpreinte: reporting.statutEmpreinte,
            statutEffectifs: reporting.statutEffectifs,
            statutAccidentologie: reporting.statutAccidentologie,
          }
        });
      }
    },
    mounted() {
      MarcheStore.getAll().then(marches => {
        this.marches = marches;
        this.marchesAdmin = marches.map(marche => {
          return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
        });
        this.marcheIdsItems = this.marchesAdmin;
      });
      LigneStore.getAll().then(
          response => this.lignes = response.map(value => {
            return {text: value.libelleLong, value: value.id};
          })
      );
    },
    methods: {
      onFilterChange: _.debounce(function () {
        this.search();
      }, 1000),
      search() {
        if (this.date) {
          const reporting = this.createReportingRecherche();
          ReportingStore.search(reporting, true).then(
              result => {
                this.reportingResult = result.data;
              },
              error => AlertStore.pushError(error.response.data.message)
          )
        }
      },
      createReportingRecherche() {
        const reporting = new ReportingSearchDto();
        reporting.marcheId = this.marcheId;
        reporting.ligneId = this.ligneId;
        reporting.statut = this.statut;
        reporting.date = momentToDate(this.date);
        return reporting;
      },
      setBackground(item) {
        return item;
      },
      onMarcheSearch(marche, isId) {
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marchesAdmin)
      },
      preventOk(evt) {
        evt.preventDefault();
      }
    }
  }
</script>
